// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__mfvsy","fluid":"NotFound_fluid__yQwgE"};